import React, { useMemo } from "react";
import { useNavigate } from 'react-router-dom';
// import EmptyComponentLinkText from '../../../components/EmptyComponent/EmptyComponentLinkText';
import * as TemplateApi from '../../../api/marketing/templateApi';
import './styles.scss';

import { ConfigProvider, Pagination, Switch, Tooltip } from "antd";
import { AgGridReact } from "ag-grid-react"
import viVN from 'antd/locale/vi_VN';
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectorPermission } from "../../../store/slices/permissionSlice";
import { checkDisabledPermission, dataPagination, getUserPermissions } from "../../../until";
import { NodataTable } from "../../../components/NoDataTable";
import { formatNumber } from "../../../services/mixin";
import { CHANNELTYPE } from "../../../services/data";
import { IPagination } from "../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { INotificationTemplate } from "../../../api/notificationTemplate/notificationTemplateApi";



interface Props {
  paginations: Record<CHANNELTYPE, IPagination>
  dataTemplates: Record<CHANNELTYPE, INotificationTemplate[]>
  gInfoNotificationTemplate: (id: number) => void
  uStatusNotificationTemplate: (id: number) => void
  openModalDelete: (id: number) => void
  onPaginationChange: ((page: number, pageSize: number) => void)
}

const SMS: React.FC<Props> = ({
  paginations, dataTemplates,
  gInfoNotificationTemplate, uStatusNotificationTemplate, openModalDelete, onPaginationChange
}) => {
  const navigate = useNavigate()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const columnDefs = useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'action',
      colId: 'action',
      width: 203,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      cellRenderer: (params: ICellRendererParams) => {
        const { id, view, status } = params.data;
        return (
          <div className="h-full d-flex align-center justify-center gap-10-px">
            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() => { gInfoNotificationTemplate(id) }}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() =>
                navigate(`/marketing/notification-templates-management/edit-sms`,
                  {
                    state: {
                      id,
                      type: CHANNELTYPE.SMS
                    }
                  })}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDelete(id)}
            />
            <Switch
              disabled={!edit}
              checked={status}
              onChange={() => {
                uStatusNotificationTemplate(Number(id));
              }}
              className="rs-switch rs-switch--sm"
            />
          </div>
        );
      }
    },
    {
      headerName: "Mã mẫu",
      field: "code",
      sortable: true,
    },
    {
      headerName: "Tên mẫu thông báo",
      field: "title",
    },
    {
      headerName: "Đơn vị / thương hiệu",
      field: "categories",
    },
    // {
    //   headerName: "Nhà mạng",
    //   field: "networkNames",
    // },
    {
      headerName: "Nội dung",
      field: "content",
      cellRenderer: (params: any) => <Tooltip
        color="white"
        overlayInnerStyle={{
          color: "#475467",
          maxHeight: '30vh',
          overflowY: 'auto',
          maxWidth: '500px',
        }}
        title={<div className=" ">{params.data.content}</div>}
      >
        <div className="">
          {params.data.content}
        </div>
      </Tooltip>
    },
    {
      headerName: "Người tạo",
      field: "adminName",
    },
    {
      headerName: "Ngày tạo",
      field: "createdAt",
      sortable: true,
    },

  ], []); // Chỉ các hàm setState

  return (
    <>
      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataTemplates[CHANNELTYPE.SMS]}
            rowHeight={55}
            columnDefs={columnDefs}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={paginations[CHANNELTYPE.SMS].current} pageSize={paginations[CHANNELTYPE.SMS].pageSize} total={paginations[CHANNELTYPE.SMS].total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(paginations[CHANNELTYPE.SMS].total, paginations[CHANNELTYPE.SMS].pageSize,
                paginations[CHANNELTYPE.SMS].current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>



    </>
  )
}

export default SMS
